<template>
  <div class="welcome">
    <div id="stripes">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div>
      <b-container>
        <div class="cover__title">
          Start now
        </div>
        <div class="cover__subtitle">
          Whether your are a startup, a publisher or a corporate - our goal is
          to empower businesses to achieve more by enabling them to launch
          digital products faster at scale unlocking new opportunities and
          business models that help them to reach their full potential.
        </div>
        <div class="benefit__margins">
          <b-card-group deck class="default-widget__group">
            <b-card
              v-for="(benefit, index) in benefits"
              :key="index"
              tag="article"
              body-class="card__body"
              style="min-width:200px;border-radius:12px;"
              class="default__card col-md-4 col-lg-4"
            >
              <div>
                <div class="benefit__name">{{ benefit.name }}</div>
                <div class="benefit__description">
                  {{ benefit.description }}
                </div>
              </div>
            </b-card>
          </b-card-group>
        </div>
      </b-container>
    </div>
    <b-container>
      <section class="section__ressources">
        <h2>Content</h2>
        <div class="benefit__margins">
          <b-card-group deck class="default-widget__group">
            <b-card
              v-for="(article, index) in articles"
              :key="index"
              tag="article"
              body-class="card__body"
              class="default__card col-md-6 col-lg-6"
            >
              <div>
                <div class="benefit__name">{{ article.name }}</div>
                <div class="benefit__description">
                  {{ article.description }}
                </div>
                <div v-if="article.link" class="default__link-ref">
                  <img :src="article.link.img" width="18px" height="15px" />
                  <a :href="article.link.path" class="default__anchor-text">
                    {{ article.link.text }}
                  </a>
                </div>
              </div>
            </b-card>
          </b-card-group>
        </div>
      </section>
      <section class="section__customers">
        <h2>Portfolio</h2>
        <div class="benefit__margins">
          <b-card-group deck class="default-widget__group">
            <b-card
              v-for="(company, index) in companies"
              :key="index"
              :img-src="company.logo"
              tag="article"
              body-class="card__body"
              class="default__card col-md-6 col-lg-6"
            >
              <div>
                <div class="benefit__name">{{ company.name }}</div>
                <div class="benefit__description">
                  {{ company.description }}
                </div>
                <div v-if="company.link" class="default__link-ref">
                  <img :src="company.link.img" width="18px" height="15px" />
                  <a :href="company.link.path" class="default__anchor-text">
                    {{ company.link.text }}
                  </a>
                </div>
              </div>
            </b-card>
          </b-card-group>
        </div>
      </section>
    </b-container>
  </div>
</template>

<script>
import linkImage from "@/assets/img/graphapi-link-deep-dive.svg";
import graphapiLogo from "@/assets/img/graphapi-serverless-graphql.svg";

export default {
  name: "Welcome",
  data: function getBenefits() {
    return {
      msg: "Build GraphQL-APIs",
      benefits: [
        {
          name: "Agility",
          description:
            "Applying frameworks like SCRUM can be hard. We make it look easy and fun.",
        },
        {
          name: "Startups",
          description:
            "For you tech setup we help you with the decisions you wish you could get right early.",
        },
        {
          name: "Product",
          description:
            "We help you understand how to maximize value for all stakeholders involved.",
        },
        {
          name: "Cloud",
          description:
            "Stop being busy with your infrastructure. We help you to automate your AWS cloud.",
        },
      ],
      articles: [
        {
          name: "The Velocity Trap",
          link: {
            img: linkImage,
            path: "https://medium.com/p/7207c0dbbad9",
            text: "Learn about the Velocity Trap",
          },
          description: `A product is a vehicle to deliver value. What is value in the context of your business?
          Could it be that your organization is caught in a velocity trap?`,
        },
        {
          name: "What is GraphQL?",
          link: {
            img: linkImage,
            path: "https://graphapi.com/learn/graphql/",
            text: "What is GraphQL?",
          },

          description: `GraphQL is a query language for APIs and a server-side runtime to fulfill those queries.
            GraphQL was created in 2012 and open-sourced by Facebook in 2015.`,
        },
        {
          name: "GraphQL vs. REST",
          link: {
            img: linkImage,
            path: "https://graphapi.com/learn/graphql/vs-rest/",
            text: "GraphQL vs. REST",
          },
          description:
            "When designing an API for the web, terms like GraphQL and REST come to mind. How can teams decide which architectural style or protocol they should use?",
        },
        {
          name: "GraphQL Server",
          link: {
            img: linkImage,
            path: "https://graphapi.com/learn/graphql/server/",
            text: "GraphQL Server",
          },
          description: `While GraphQL APIs are easier to integrate for application developers, they can be challenging
            for the teams tasked with creating them.`,
        },
        {
          name: "GraphQL Queries",
          link: {
            img: linkImage,
            path: "https://graphapi.com/learn/graphql/query/",
            text: "GraphQL Query",
          },
          description: `The GraphQL query is one of the core operations of GraphQL. With a single endpoint,
            App developers can retrieve data from a GraphQL server using queries.`,
        },
      ],
      companies: [
        {
          name: "GraphApi.io GmbH",
          logo: graphapiLogo,
          link: {
            img: linkImage,
            path: "https://graphapi.com",
            text: "GraphQL Backend-as-a-Service",
          },
          description: `graphapi® is a low-code GraphQL Backend-as-a-Service platform optimized for developer productivity and instant collaboration.
          Its cloud automation backend and built-in CMS capabilities free up development resources and empower teams to launch faster at scale.`,
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/scss/variables";
@import "../../node_modules/bootstrap/scss/functions";
@import "../../node_modules/bootstrap/scss/variables";
@import "../../node_modules/bootstrap/scss/mixins/breakpoints";

.welcome {
  margin: 0;
  text-align: left;
}

.card.card.card {
  padding: 0;
  line-height: 1.3;
  margin: 0;
  min-width: 80%;
  border: 0;

  @include media-breakpoint-up(md) {
    min-width: calc(33% - 10px);
    max-width: calc(33% - 10px);
  }
}

.welcome .member__card {
  min-width: 15rem;
  border-radius: 18px;
  padding: 0;
  margin: 0;
  flex: 0 0 calc(33% - 20px);
}

.default__anchor-text {
  margin-left: 0.5rem;
}

.default__link-ref {
  align-items: center;
  display: flex;
  font-size: em(14);
  margin-top: 0.5rem;
}

.default-widget__group.card-deck {
  display: flex;
  flex-direction: column;
  margin-left: 0;
  margin-right: 0;
  margin-top: 20px;
  gap: 20px;

  @include media-breakpoint-up(md) {
    flex-direction: row;
  }
}

#stripes {
  z-index: -2;
  margin-top: -40px;
  width: 100%;
  height: 100%;
  max-height: 493px;
  overflow: hidden;
  -webkit-transform: skewY(-0deg);
  transform: skewY(-0deg);
  -webkit-transform-origin: 0;
  transform-origin: 0;
  background: linear-gradient(150deg, #53f 15%, #05d5ff 70%, #a6ffcb 94%);
}

#stripes,
#stripes span {
  position: absolute;
}

#stripes span {
  height: 130px;
}

#stripes :first-child {
  top: 0;
  width: 100%;
  left: calc(calc(calc(100% / 3) / 2) * -1);
  bottom: auto;
  background: #53f;

  @include media-breakpoint-up(md) {
    width: calc(100% / 3);
  }
}

#stripes :nth-child(2) {
  background: #4553ff;
  width: calc(100% / 3);
  top: 0;
  left: calc(calc(100% / 2));
  right: auto;

  @include media-breakpoint-up(md) {
    left: calc(calc(100% / 3) / 2);
  }
}

#stripes :nth-child(3) {
  background: #4f40ff;
  width: calc(100% / 3);
  left: calc(calc(calc(100% / 3) / 2) + calc(100% / 3));
  right: auto;
  bottom: auto;
}

#stripes :nth-child(4) {
  background: #25ddf5;
  width: calc(100% / 3);
  top: 380px;
  top: calc(190px * 2);
  right: calc(calc(calc(100% / 3) / 2) * -1);
}

#stripes :nth-child(5) {
  background: #1fa2ff;
  width: calc(100% / 3);
  bottom: 0;
}

.cover__title {
  color: $header-font-color;
  font-size: 48px;
  font-weight: bold;
  margin-top: 40px;
}

.cover__subtitle {
  color: rgba($header-font-color, 0.9);
  margin-top: 40px;
  font-size: 18px;

  @include media-breakpoint-up(md) {
    max-width: 75%;
  }
}

.benefit__margins {
  margin-top: 40px;

  @include media-breakpoint-up(md) {
    margin-top: 40px;
  }
}

.benefit__name {
  font-size: 22px;
  font-weight: bold;
  color: black;
  text-align: left;
}

.benefit__description {
  margin-top: 10px;
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: rgba(0, 0, 0, 0.5);
}

.card__body {
  padding: 20px;
}

.card__body--shadow {
  box-shadow: 0 40px 30px -20px rgba(0, 0, 0, 0.2);
  padding: 20px;
}

.section__ressources {
  margin-top: 80px;

  @include media-breakpoint-up(md) {
    margin-top: 150px;
  }
}

.section__customers {
  margin-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue